export default __webpack_public_path__ + "static/media/dc-blue.cc8169a3.jpg";